import { isComposing } from './KeyboardHelpers';

const DOUBLE_ENTER_INTERVAL = 1000;

// Each composer owns its own sequence. IME confirmation and held keys never
// count as a press, and any other key starts a new sequence.
export const createDoubleEnterHandler = () => {
  let lastEnterAt = null;
  const reset = () => {
    lastEnterAt = null;
  };

  const onKeydown = event => {
    if (
      event.key !== 'Enter' ||
      event.shiftKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      event.repeat ||
      isComposing(event)
    ) {
      reset();
      return 0;
    }

    const now = performance.now();
    if (lastEnterAt !== null && now - lastEnterAt <= DOUBLE_ENTER_INTERVAL) {
      reset();
      return 2;
    }
    lastEnterAt = now;
    return 1;
  };

  return { onKeydown, reset };
};
